module.exports = __webpack_public_path__ + "static/media/subscribers-sad.7f85d298.svg";